import Button from '@/shared/components/Button/Button'
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import TextComponent from '@/shared/components/TextComponent/TextComponent'
import { NavLink } from 'react-router-dom'
import styles from '@/features/auth/Forms/ResetPasswordEmail/ResetPasswordEmail.module.scss'
import { getFormConfig } from '@/features/auth/Forms/ResetPasswordEmail/ResetPasswordEmailFormConfig'

function ResetPasswordEmail() {
  const [isDirty, setIsDirty] = useState(true)
  const { t } = useTranslation()
  const formConfig = getFormConfig(t)
  return (
    <div className={`${styles.resetPasswordEmailContainer}`}>
      <h1 className={`title-bold-medium ${styles.resetPasswordEmailHeader}`}>
        {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.TITLE.FIRST_PART')}
        <mark className="mark-orange">
          {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.TITLE.SECOND_PART')}
        </mark>{' '}
        {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.TITLE.THIRD_PART')}
      </h1>
      <p className={`body-bold-medium ${styles.resetPasswordEmailSubHeader}`}>
        {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.SUB_TITLE.FIRST_PART')}{' '}
        <mark className="mark-orange">
          {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.SUB_TITLE.SECOND_PART')}
        </mark>{' '}
        {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.SUB_TITLE.THIRD_PART')}
      </p>
      <DynamicForm setIsDirty={setIsDirty} validationMode="onSubmit" {...formConfig} />
      <div className={`${styles.backToLoginContainer}`}>
        <p className={`body-bold-medium ${styles.changedYourMindMessage}`}>
          {t('AUTHORIZATION.RESET_PASSWORD_EMAIL.CHANGED_YOUR_MIND')}
        </p>
        <NavLink to="/login">
          <TextComponent
            text={t('AUTHORIZATION.RESET_PASSWORD_EMAIL.BACK_TO_LOGIN')}
            fontSize="body-bold-medium"
            color="secondary"
            underline
            onclick={() => {}}
          />
        </NavLink>
      </div>
      <div className={`${styles.resetPasswordEmailFormButtonContainer}`}>
        <Button
          form="reset-password-email-form"
          onClick={() => {}}
          label={t('AUTHORIZATION.RESET_PASSWORD_EMAIL.SEND_MESSAGE')}
          variant="contained"
          color="primary"
          type="submit"
          maxWidth
          disabled={isDirty}
        />
      </div>
    </div>
  )
}

export default ResetPasswordEmail
